import moment from 'moment';

export const returnDateHourFormatedString = (date: number) => {
  return `${moment(date).format('L')} às ${moment(date).format('LT')}`;
};
